var map = {
	"./01 - 20X40_Cut 20 Side 1.20 mm.jpg": 3746,
	"./02 - 20X40_Cut 40 Side 1.20 mm.jpg": 314,
	"./03 - 25X25 1.20 mm.jpg": 4566,
	"./06.jpg": 8949,
	"./09.jpg": 1003,
	"./12.jpg": 9450,
	"./13.jpg": 1496,
	"./77.jpg": 170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9404;